import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function FinalCtaSection() {
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-47">
      <div className="absolute inset-0 bg-gradient-to-b from-dark to-gray-900" data-id="element-48"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-50">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-51">
            Consigue más clientes con una web profesional
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-52">
            Cada día más clientes buscan servicios en internet. La pregunta es
            simple:
            <br className="hidden md:block" data-id="element-53" />
            <span className="text-white font-semibold mt-2 block" data-id="element-54">
              ¿Encontrarán tu negocio o el de tu competencia?
            </span>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-55">
            
            <a href="https://wa.me/34600000000" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-lg text-white border-2 border-white/20 hover:bg-white/10 transition-colors" data-id="element-56">
              <MessageCircleIcon className="w-5 h-5" data-id="element-57" />
              Hablar por WhatsApp
            </a>
          </div>

          <p className="mt-6 text-sm text-gray-400" data-id="element-58">
            🔥 Oferta de lanzamiento disponible este mes.
          </p>
        </motion.div>
      </div>
    </section>;
}